import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, finalize, switchMap, timer } from 'rxjs';
import { Helper } from '@my-util/helper';
import { LoaderService } from '@my-services/loader.service';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  count = 0;

  constructor(public loaderService: LoaderService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!Helper.isHideLoader) {
      this.count++;
      if (this.count === 1) {
        this.loaderService.show();
      }
    }
    // return next.handle(request);
    return timer(50).pipe(switchMap(() => next.handle(request).pipe(finalize(() => {  // after pipe bracket = tap(data => console.log(data)),
      if (!Helper.isHideLoader) {
        this.count--;
        if (this.count <= 0) {
          this.loaderService.hide();
          this.count = 0;
        }
      }
    })
    ))   // <== Switch to the Http Stream
    )
  }
}
